import React from "react";
import { Button, Space, Tag } from "antd";
import { formatDate } from "../../../../utility/commonConstant";


const roleStyles = {
  admin: {
    color: "var(--color-primary-100)",
    background: "var(--color-primary-05)",
    borderColor: "var(--color-secondary-30)",
  },
  manager: {
    color: "var(--color-secondary-100)",
    background: "var(--color-secondary-05)",
    borderColor: "var(--border-error)",
  },
  default: {
    color: "var(--blue)",
    background: "var(--light-blue)",
    borderColor: "var(--blue-80)",
  },
};


export const getUsersColumns = (onViewDetails) => [
  {
    title: "Name",
    dataIndex: "fullName",
    key: "fullName",
    width: 200,
    render: (name) => <Space>{name}</Space>,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 250,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    align: "center",
    width: 250,
    render: (role) => {
      if (!role) return null;
      const styles = roleStyles[role.toLowerCase()] ?? roleStyles.default;
      const formattedRole = role.replace(/_/g, " ");

      return (
        <Tag
          className="!px-4 !py-[10px] !rounded-[10px] !border !font-medium"
          style={{
            color: styles.color,
            borderColor: styles.borderColor,
            backgroundColor: styles.background,
            width: "131px",
            textAlign: "center",
          }}
        >
          {formattedRole}
        </Tag>
      );
    },
  },
  {
    title: "Manager",
    dataIndex: "managerName",
    key: "managerName",
    width: 250,
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 250,
    render: (date) => formatDate(date, "DD-MMM-YYYY"),
  },
  {
    title: "Action",
    key: "action",
    width: 50,
    onCell: () => ({ className: "text-right pr-12" }),
    render: (_, record) => (
      <Button
        type="link"
        className="!text-[rgba(145,14,17,1)] underline !p-0 text-left"
        onClick={() =>
          onViewDetails(record.userId, record.fullName)
        }
      >
        View Details
      </Button>
    ),
  },
];